import styled from 'styled-components'

export const ErrorText = styled.div`
	color: red;
	margin: 20px 0;
	&:last-child {
		margin-bottom: 0;
	}
`
